import { useQuery } from '@tanstack/react-query';
import queryString from 'query-string';
import { useState } from 'react';
import { generatePath } from 'react-router-dom';

import { API_CUSTOM_SEGMENTS_LIST_URL } from '../constants/apiUrls';
import { getRequestJSON } from '../util/services';
import { useConfig } from './useConfig';

function useAudiences(nameFilter, pageDefault = 1, perPageDefault = 25) {
  const { apiHost } = useConfig();
  const [page, setPage] = useState<number>(pageDefault);
  const [perPage, setPerPage] = useState<number>(perPageDefault);
  const query = useQuery({
    queryKey: ['audiences', page, perPage, nameFilter],
    queryFn: () =>
      getRequestJSON(
        apiHost,
        generatePath(API_CUSTOM_SEGMENTS_LIST_URL, {
          '*': `?${queryString.stringify({
            page: page.toString(),
            size: perPage,
            name_filter: nameFilter,
          })}`,
        })
      ),
  });

  return {
    page,
    setPage,
    perPage,
    setPerPage,
    ...query,
  };
}

export default useAudiences;
